document.addEventListener("DOMContentLoaded", function () {
  const priceEl = document.getElementById("asProdPagePrice");

  function updatePrice() {
    const selections = {};

    document.querySelectorAll(".variant-input:checked").forEach(input => {
      selections[input.name] = input.value;
      const label = document.querySelector(
        `.variant-wrapper label.as-prd-page-label[for="${input.name}"] .selected-value`
      );
      if (label) {
        label.textContent = input.value;
      }
    });

    let matched = null;

    window.productVariants.forEach(v => {
      let isMatch = true;

      v.options.forEach((opt, i) => {
        if (opt !== selections[v.option_names[i]]) {
          isMatch = false;
        }
      });

      if (isMatch) matched = v;
    });

    if (matched) {
      priceEl.innerHTML = matched.price_formatted;
    }
  }

  document.querySelectorAll(".variant-input").forEach(input => {
    input.addEventListener("change", function() {
      updatePrice();

      // Check if this is a color variant change
      var parentWrapper = this.closest('.variant-wrapper');
      if (parentWrapper) {
        var label = parentWrapper.querySelector('label.as-prd-page-label');
        if (label) {
          var labelText = label.getAttribute('for') || '';
          var labelLower = labelText.toLowerCase();
          if (labelLower === 'color' || labelLower === 'colour' || labelLower === 'shade' || labelLower === 'pattern') {
            // Get the selected color value and convert to handle format
            var selectedColor = this.value.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
            if (typeof window.filterSwiperByColor === 'function') {
              window.filterSwiperByColor(selectedColor);
            }
          }
        }
      }
    });
  });

  const addBtn = document.getElementById("asAddToCartBtn");
  if (addBtn) {
    addBtn.addEventListener("click", function () {
      const checkedOptions = {};
      document.querySelectorAll(".variant-input:checked").forEach(input => {
        checkedOptions[input.name] = input.value;
      });

      let selectedVariant = null;

      if (window.productVariants && window.productVariants.length > 0) {
        window.productVariants.forEach(variant => {
          let match = true;

          variant.options.forEach((opt, index) => {
            if (opt !== checkedOptions[variant.option_names[index]]) {
              match = false;
            }
          });

          if (match) selectedVariant = variant;
        });

        // Fallback to first variant if match wasn't found (e.g. single variant product)
        if (!selectedVariant && window.productVariants.length === 1) {
          selectedVariant = window.productVariants[0];
        }
      }

      if (!selectedVariant) {
        alert("Please select your size and options first.");
        return;
      }

      addBtn.disabled = true;
      addBtn.style.opacity = '0.7';
       
      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          id: selectedVariant.id,
          quantity: 1
        })
      })
        .then(res => {
          if (!res.ok) throw new Error("Add to cart failed");
          return res.json();
        })
        .then(data => {
          //  window.location.href = "/checkout";
            if (window.gokwikSdk && typeof window.gokwikSdk.initCheckout === "function") {
             window.gokwikSdk.initCheckout(merchantInfo);
        addBtn.disabled = false;
                  addBtn.style.opacity = '1';
             
           } else {
             console.error("GoKwik SDK not ready");
             
           }
                
        })
        .catch(err => {
          console.error("Error adding to cart:", err);
          addBtn.disabled = false;
          addBtn.style.opacity = '1';
          alert("Something went wrong while processing your order. Please try again.");
        });
    });
  }
});

const readMoreBtn = document.querySelector('.read-more-btn');
if (readMoreBtn) {
  readMoreBtn.addEventListener('click', function () {
    const container = this.closest('.as-prd-page-desc');
    const shortText = container.querySelector('.desc-short');
    const fullText = container.querySelector('.desc-full');

    if (this.textContent === '... more') {
      shortText.style.display = 'none';
      fullText.style.display = 'inline';
      this.textContent = '... less';
    } else {
      shortText.style.display = 'inline';
      fullText.style.display = 'none';
      this.textContent = '... more';
    }
  });
}